import { getDemoActivityLabelById, mockLabels } from '@web/lib/demo/data/labels';
import { ActivityLabelConditionTypeEnum } from '@workalizer/shared';
import { UNCATEGORIZED_LABEL_NAME } from '@workalizer/shared/config';
export function matchesDemoActivityLabel(title, label) {
    var titleLower = title.toLowerCase();
    return label.rules.some(function (rule) {
        return rule.conditions.some(function (condition) {
            var keyword = condition.keyword.toLowerCase();
            switch (condition.type) {
                case ActivityLabelConditionTypeEnum.CONTAINS:
                    return titleLower.includes(keyword);
                case ActivityLabelConditionTypeEnum.STARTS_WITH:
                    return titleLower.startsWith(keyword);
                case ActivityLabelConditionTypeEnum.DOES_NOT_CONTAIN:
                    return !titleLower.includes(keyword);
                default:
                    return false;
            }
        });
    });
}
export function matchesAnyDemoActivityLabel(title) {
    return mockLabels.some(function (label) { return matchesDemoActivityLabel(title, label); });
}
export function matchesDemoActivityLabelFilter(title, activityLabelId) {
    if (!activityLabelId) {
        return true;
    }
    var label = getDemoActivityLabelById(activityLabelId);
    if (!label) {
        return true;
    }
    return matchesDemoActivityLabel(title, label);
}
export function isDemoUncategorizedTitle(title) {
    return !matchesAnyDemoActivityLabel(title);
}
export { UNCATEGORIZED_LABEL_NAME };
